export const getTwitterLink = (handle: string) => {
  return `https://twitter.com/${sanitizeHandle(handle)}`
}

export const getFacebookLink = (handle: string) => {
  return `https://facebook.com/${sanitizeHandle(handle)}`
}

export const getInstagramLink = (handle: string) => {
  return `https://instagram.com/${sanitizeHandle(handle)}`
}

const sanitizeHandle = (handle: string) => {
  return handle.replace('@', '')
}
